<ui-page-container size="medium">
  <mat-card>
    <mat-card-title>
      {{ (entityId ? 'Modifica media' : 'Aggiungi media') | translate }}
    </mat-card-title>
    <mat-card-content>
      <form
        class="media-container"
        *ngIf="entityForm"
        [formGroup]="entityForm"
        (ngSubmit)="dispatchAction(entityForm)">
        <div class="media-image-container">
          <img
            *ngIf="imageUrl; else imagePlaceholder"
            loading="lazy"
            [src]="imageUrl"
            (click)="showMediaHandler(entityForm.value)">

          <ng-template #imagePlaceholder>
            <img
              class="media-placeholder"
              loading="lazy"
              src="./assets/images/card-placeholder.png">
          </ng-template>
        </div>
        <div class="media-info-container">
          <p>{{ 'Path: ' + entityForm.value.path }}</p>
          <p>{{ 'Name: ' + mediaName }}</p>
          <p>{{ 'Tipo di file: ' + mediaType }}</p>

          <mat-form-field>
            <textarea
              matInput
              formControlName="note"
              [placeholder]="'Note' | translate"></textarea>
          </mat-form-field>
          <app-tags-form
            [form]="entityForm?.get('tags')"
            [classNames]="['File']">
          </app-tags-form>

          <div class="media-actions">
            <button
              mat-button
              mat-raised-button
              type="button"
              (click)="remove(entityForm.value)">
              {{ 'Elimina' | translate }}
            </button>
            <button
              mat-button
              mat-raised-button
              type="submit"
              color="primary">
              {{ 'Salva' | translate }}
            </button>
          </div>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</ui-page-container>
